<template>
  <div class="bg-brand-background dark:text-white">
    <router-view />
    <l-loading></l-loading>
  </div>
</template>
<script>
import LLoading from "@/components/loading/LLoading";

export default {
  components: { LLoading },
  mounted() {
    this.$store.dispatch("checkLoginStatus");
  },
};
</script>
<style lang="scss">
#app {
  font-family: "Josefin Sans", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
